export const isPopupBlocked = (newWindow: Window): boolean =>
  !newWindow || newWindow.closed || typeof newWindow.closed === 'undefined';
